/*
 * Error Manager Component: It is responsible for rendering error modal.
 */

import React, { Component, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { CQAppStore } from '../../../store/cq-app-store';

/**
 * @export
 * @class ErrorManager
 * @extends Component
 */
class SuccessManager extends Component<{}, {}> {

    public renderSuccessModal(): ReactNode {
        const { successMessage } = CQAppStore.success;
        return (
            <div className="slds-notify_container">
                <div className="slds-notify slds-notify_toast slds-theme_success" role="status">
                    <div className="slds-notify__content">
                        <h2 className="slds-text-heading_small ">{successMessage}</h2>
                    </div>
                    <div className="slds-notify__close">
                        <button className="slds-button slds-button_icon slds-button_icon-inverse" title="Close" onClick={() => this.hideToast()}>
                            <i className="cq-2x cq-icon-close"></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }


    /**
     * @returns {ReactNode}
     * @memberof ErrorManager
     */
    public render(): ReactNode {
        const { successFlag } = CQAppStore.success;
        
        if (!successFlag) {
            return null
        }
        return (
            <div>
                {this.renderSuccessModal()}
            </div>
        )
    }

    /**
     * @memberof SuccessManager
     */
    public hideToast = () => {
        CQAppStore.success.hide();
    }
}

export const SuccessManagerComponent = observer(SuccessManager);
